var BaseView = require('./baseShapePropertyView');


module.exports = BaseView.extend({

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/notePropertyViews/shapeProperties/highlight.js
 ** module id = 601
 ** module chunks = 0
 **/